import { BaseModel } from "sjs-base-model";

export default class CqsOnlineRichiestaDettaglioDocumentoViewModel extends BaseModel {
    public readonly idDoc?: number = undefined;
    public readonly descrizione: string = "";
    public readonly macropratica: string = "";
    public readonly sottopratica: string = "";
    public readonly tipodocumentoCSE: string = "";
    public readonly uploadCompleto: boolean = false;
    public readonly path: string = "";
    public readonly chiaveDoc: string = "";
    public readonly tipoDocumento: number = 0;
    public readonly base64File: string = "";
    public readonly contentType: string = "";
    public readonly idDocConfigCqsOL: number = 0;
    public readonly idTipoDocumentoCqsOl?: number = undefined;
    public readonly tipoFirma: string = "";
    public readonly modalitaSblocco: string = "";
    public readonly nomeReportCdocx: string = "";
    public readonly idStampaCdocx?: number = undefined;
    public readonly file?: Blob = undefined;
    public readonly fgObbligatorio: string = "";

    constructor(data: Partial<CqsOnlineRichiestaDettaglioDocumentoViewModel>) {
        super();

        this.update(data);
    }
}
